import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/layout.vue'

Vue.use(VueRouter)
// 解决触发同一路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
/**
 * hiddenMenu: ------------------默认false  设为true是不显示在菜单项里
 * id:         ------------------后台对应  不要改
 * name: ------------------------一级菜单不要写，------ 面包屑会用到
 * meta: {
 *  title: 'title'  the name show in sidebar and breadcrumb (recommend set)
 *  icon: '' 目前一级菜单设置  二级不用
 * }
 */

// 固定路由  只留了 登录  注册  找回密码
export const constantRoutes = [
  // DATA_V
  {
    path: '/dataV_A',
    name: 'dataV_A',
    hiddenMenu: true,
    meta: {
      title: '报名审核缴费数据大屏'
    },
    component: () => import('@/views/system/dataV/dataV_A.vue')
  },
  {
    path: '/dataV_B',
    name: 'dataV_B',
    hiddenMenu: true,
    meta: {
      title: '考试数据大屏'
    },
    component: () => import('@/views/system/dataV/dataV_B.vue')
  },
  {
    path: '/dataV_C',
    name: 'dataV_C',
    hiddenMenu: true,
    meta: {
      title: '评阅数据大屏'
    },
    component: () => import('@/views/system/dataV/dataV_C.vue')
  },
  // 登录
  {
    path: '/login',
    name: 'Login',
    hiddenMenu: true,
    meta: {
      title: '登录'
    },
    component: () => import('@/views/Login.vue')
  },
  // 学生端
  {
    path: '/stuHome',
    name: 'stuHome',
    redirect: '/stuHome/home',
    component: () => import('@/views/student/stuHome.vue'),
    children: [
      {
        path: '/stuHome/register',
        name: 'register',
        meta: {
          isStudent: true
        },
        component: () => import('@/views/student/register/register.vue'),
      },
      {
        path: '/stuHome/resetPassword',
        name: 'resetPassword',
        meta: {
          isStudent: true
        },
        component: () => import('@/views/student/resetPassword/resetPassword.vue'),
      },
    ]
  },
  {
    path: "/placeInfo",
    name: "placeInfo",
    hiddenMenu: true,
    meta: {
      title: "考点详情"
    },
    component: () => import("@/views/others/placeInfo.vue")
  },
  {
    path: "/certificateInfo",
    name: "certificateInfo",
    hiddenMenu: true,
    meta: {
      title: "合格证"
    },
    component: () => import("@/views/others/certificateInfo.vue")
  },
  {
    path: "/violationPhotos",
    name: "violationPhotos",
    hiddenMenu: true,
    meta: {
      title: "违纪照片"
    },
    component: () => import("@/views/others/violationPhotos.vue")
  },
  {
    path: "/uploadDocument",
    name: "uploadDocument",
    hiddenMenu: true,
    meta: {
      title: "纸质单据"
    },
    component: () => import("@/views/others/uploadDocument.vue")
  },
  {
    path: "/error",
    name: "error",
    hiddenMenu: true,
    meta: {
      title: "错误信息"
    },
    component: () => import("@/views/others/error.vue")
  },
  {
    path: "/examReportPDF",
    name: "examReportPDF",
    hiddenMenu: true,
    meta: {
      title: "考试分析报告"
    },
    component: () => import("@/views/others/examReportPDF.vue")
  },
  {
    path: '/test',
    name: 'test',
    hiddenMenu: true,
    component: () => import('@/views/others/test.vue')
  },
  {
    path: '/askExam',
    name: 'askExam',
    hiddenMenu: true,
    meta: {
      title: "参考意向问卷"
    },
    component: () => import('@/views/others/askExam.vue')
  },
]

// 管理端路由表  学生端路由在 modules/student.js里配
export const asyncRoutes = [
  // 首页
  {
    path: '/',
    id: '1',
    name: 'Home',
    component: Layout,
    redirect: '/index',
    meta: {
      title: '首页',
      icon: 'home-icon.png',
    },
    noShowingChildren: true,
    children: [
      {
        path: 'index',
        id: '1',
        name: 'index',
        component: () => import('@/views/newIndex'),
        meta: {
          title: '首页'
        },
      },
    ]
  },
  // 新版首页
  {
    path: '/',
    id: '1',
    name: 'NewIndex',
    component: Layout,
    redirect: '/NewIndex',
    meta: {
      title: '首页',
      icon: 'home-icon.png',
    },
    hiddenMenu: true,
    noShowingChildren: true,
    children: [
      {
        path: 'newIndex',
        name: 'newIndex',
        id: '1',
        // hiddenMenu: true,
        component: () => import('@/views/index.vue'),
        meta: {
          title: "新首页"
        }
      },
      // 考试数据包导出 下载页面
      {
        path: 'exportDownInfo',
        name: 'exportDownInfo',
        id: '1',
        component: () => import('@/views/exportDownInfo.vue'),
        hiddenMenu: true,
        meta: {
          title: '消息列表'
        }
      },
    ]
  },

  // 基础设置
  {
    path: '/',
    id: '2',
    component: Layout,
    redirect: '/school',
    meta: {
      title: '基础设置',
      icon: 'paper-icon.png',
    },
    children: [
      {
        path: 'school',
        name: 'school',
        id: '2-1',
        component: () => import('@/views/baseSet/school/school.vue'),
        meta: {
          title: '学校管理'
        }
      },
      {
        path: 'station',
        name: 'station',
        id: '2-2',
        component: () => import('@/views/baseSet/station/station.vue'),
        meta: {
          title: '教学点管理'
        }
      },
      {
        path: 'examSite',
        name: 'examSite',
        id: '2-3',
        component: () => import('@/views/baseSet/examSite/examSite.vue'),
        meta: {
          title: '考点管理'
        },
        children: [
          {
            path: 'add',
            name: 'addSite',
            id: '2-3',
            meta: {
              title: '新增考点'
            },
            component: () => import('@/views/baseSet/examSite/addSite.vue')
          },
          {
            path: 'edit',
            name: 'editSite',
            id: '2-3',
            meta: {
              title: '编辑考点'
            },
            component: () => import('@/views/baseSet/examSite/addSite.vue')
          }
        ]
      },
      {
        path: 'classroom',
        name: 'classroom',
        id: '2-4',
        component: () => import('@/views/baseSet/classroom/classroom.vue'),
        meta: {
          title: '教室管理'
        }
      },
      {
        path: 'level',
        name: 'level',
        id: '2-5',
        component: () => import('@/views/baseSet/level/level.vue'),
        meta: {
          title: '层次管理'
        }
      },
      {
        path: 'major',
        name: 'major',
        id: '2-6',
        component: () => import('@/views/baseSet/major/major.vue'),
        meta: {
          title: '专业管理'
        },
      },
      {
        path: 'course',
        name: 'course',
        id: '2-7',
        component: () => import('@/views/baseSet/course/course.vue'),
        meta: {
          title: '课程管理'
        },
        children: [
          {
            path: 'addSubCourse',
            name: 'addSubCourse',
            id: '2-7',
            meta: {
              title: '设置单科课程'
            },
            component: () => import('@/views/baseSet/course/addSubCourse.vue'),
          },
        ]
      },
      {
        path: 'majorCourse',
        name: 'majorCourse',
        id: '2-8',
        component: () => import('@/views/baseSet/majorCourse/majorCourse.vue'),
        meta: {
          title: '专业课程设置'
        },
        children: [
          {
            path: 'addMajorCourse',
            name: 'addMajorCourse',
            id: '2-8',
            meta: {
              title: '添加专业课程'
            },
            component: () => import('@/views/baseSet/majorCourse/majorCourseAdd.vue'),
          },
        ]
      },
      {
        path: 'ots',
        name: 'ots',
        id: '2-9',
        component: () => import('@/views/ots.vue'),
        meta: {
          title: '试题试卷管理'
        }
      },
      {
        path: 'standardTask',
        name: 'standardTask',
        id: '2-10',
        component: () => import('@/views/baseSet/standardTask/standardTask.vue'),
        meta: {
          title: '试题智能导入'
        },
        children: [
          {
            path: 'add',
            name: 'standardTaskAdd',
            id: '2-10',
            meta: {
              title: '上传试题'
            },
            component: () => import('@/views/baseSet/standardTask/standardTaskAdd.vue'),
          },
          {
            path: 'format',
            name: 'standardFormat',
            id: '2-10',
            meta: {
              title: '题目入库'
            },
            component: () => import('@/views/baseSet/standardTask/standardFormat.vue'),
          },
        ]
      },
    ]
  },
  // 考试管理
  {
    path: '/',
    component: Layout,
    id: '4',
    redirect: '/examBatch',
    meta: {
      title: '考试管理',
      icon: 'exam-icon.png',
    },
    children: [
      {
        path: 'examBatch',
        name: 'examBatch',
        id: '4-1',
        component: () => import('@/views/examSet/examBatch/examBatch.vue'),
        meta: {
          title: '批次管理'
        },
        children: [
          {
            path: 'add',
            name: 'addBatch',
            id: '4-1',
            meta: {
              title: '新增考试批次'
            },
            component: () => import('@/views/examSet/examBatch/addBatch.vue')
          },
          {
            path: 'edit',
            name: 'editBatch',
            id: '4-1',
            meta: {
              title: '编辑考试批次'
            },
            component: () => import('@/views/examSet/examBatch/addBatch.vue')
          },
          {
            path: 'check',
            name: 'checkBatch',
            id: '4-1',
            meta: {
              title: '查看考试批次'
            },
            component: () => import('@/views/examSet/examBatch/checkBatch.vue')
          },
          {
            path: 'addUpload',
            name: 'addUpload',
            id: '4-1',
            meta: {
              title: '考生上传附件设置'
            },
            component: () => import('@/views/examSet/examBatch/addUpload.vue')
          },
        ]
      },
      {
        path: 'mockExam',
        name: 'mockExam',
        id: '4-2',
        component: () => import('@/views/examSet/mockExam/mockExam.vue'),
        meta: {
          title: '试考设置'
        },
      },
      {
        path: 'planMock',
        name: 'planMock',
        id: '4-15',
        component: () => import('@/views/examSet/planMock/planMock.vue'),
        meta: {
          title: '模考设置'
        },
      },
      {
        path: 'studentMock',
        name: 'studentMock',
        id: '4-16',
        component: () => import('@/views/examSet/studentMock/studentMock.vue'),
        meta: {
          title: '模考查询'
        },
        children:[
          {
            path: 'studentMockList',
            name: 'studentMockList',
            id: '4-16',
            meta: {
              title: '模考查询详情'
            },
            component: () => import('@/views/examSet/studentMock/studentMockList.vue')
          }
        ]
      },
      {
        path: 'sectionList',
        name: 'sectionList',
        id: '4-3',
        component: () => import('@/views/examSet/section/sectionList.vue'),
        meta: {
          title: '场次设置'
        },
        children: [
          {
            path: 'section',
            name: 'section',
            id: '4-3',
            meta: {
              title: '场次设置'
            },
            component: () => import('@/views/examSet/section/section.vue')
          },
          {
            path: 'add',
            name: 'addSection',
            id: '4-3',
            meta: {
              title: '新增场次'
            },
            component: () => import('@/views/examSet/section/addSection.vue')
          },
          {
            path: 'edit',
            name: 'editSection',
            id: '4-3',
            meta: {
              title: '编辑场次'
            },
            component: () => import('@/views/examSet/section/addSection.vue')
          },
          {
            path: 'sectionVenue',
            name: 'sectionVenue',
            id: '4-3',
            meta: {
              title: '场次配置'
            },
            component: () => import('@/views/examSet/section/sectionVenue.vue')
          },
          {
            // showVenue
            path: 'showVenue',
            name: 'showVenue',
            id: '4-3',
            meta: {
              title: '查看场次配置'
            },
            component: () => import('@/views/examSet/section/showVenue.vue')
          },
          {
            path: 'look',
            name: 'sectionLook',
            id: '4-3',
            meta: {
              title: '场次查看'
            },
            component: () => import('@/views/examSet/section/sectionLook.vue')
          }
        ]
      },
      {
        path: 'examActivity',
        name: 'examActivity',
        id: '4-12',
        component: () => import('@/views/examSet/examActivity/examActivity.vue'),
        meta: {
          title: '考试活动设置'
        },
      },
      {
        path: 'confirmChangePaper',
        name: 'confirmChangePaper',
        id: '4-14',
        component: () => import('@/views/examSet/examActivity/confirmChangePaper.vue'),
        meta: {
          title: '机房断网试卷变更确认'
        },
      },
      {
        path: 'classList',
        name: 'classList',
        id: '4-4',
        component: () => import('@/views/examSet/classSet/classList.vue'),
        meta: {
          title: '考场安排'
        },
        children: [
          {
            path: 'classSet',
            name: 'classSet',
            id: '4-4',
            meta: {
              title: '考场安排查看'
            },
            component: () => import('@/views/examSet/classSet/classSet.vue')
          },
          {
            path: 'ManualSet',
            name: 'ManualSet',
            id: '4-4',
            meta: {
              title: '手动安排'
            },
            component: () => import('@/views/examSet/classSet/ManualSet')
          },
          {
            path: 'history',
            name: 'historyClass',
            id: '4-4',
            meta: {
              title: '历史查询'
            },
            component: () => import('@/views/examSet/classSet/history.vue')
          },
          {
            path: 'student',
            name: 'student',
            id: '4-4',
            meta: {
              title: '考生安排'
            },
            component: () => import('@/views/examSet/classSet/student.vue')
          },
          {
            path: 'manualAdjustment',
            name: 'manualAdjustment',
            id: '4-4',
            meta: {
              title: '手动调整'
            },
            component: () => import('@/views/examSet/classSet/manualAdjustment.vue')
          },
          {
            path: 'specifyAdjustments',
            name: 'specifyAdjustments',
            id: '4-4',
            meta: {
              title: '单个调整'
            },
            component: () => import('@/views/examSet/classSet/specifyAdjustments.vue')
          }
        ]
      },
      {
        path: 'setInspector',
        name: 'setInspector',
        id: '4-11',
        component: () => import('@/views/examSet/classSet/setInspector.vue'),
        meta: {
          title: '设置巡考员'
        },
        children: [
          {
            path: 'setInspectorAssistant',
            name: 'setInspectorAssistant',
            id: '4-11',
            meta: {
              title: '设置巡考员'
            },
            component: () => import('@/views/examSet/classSet/setInspectorAssistant.vue'),
          },
        ]
      },
      {
        path: 'viewExamcode',
        name: 'viewExamcode',
        id: '4-10',
        meta: {
          title: '查看考试口令'
        },
        component: () => import('@/views/examSet/classSet/viewExamcode'),
        children: [
          {
            path: 'viewExamcodeLook',
            name: 'viewExamcodeLook',
            id: '4-10',
            meta: {
              title: '查看考试口令'
            },
            component: () => import('@/views/examSet/classSet/viewExamcodeLook')
          }
        ]
      },
      {
        path: 'ClassSetExport',
        name: 'ClassSetExport',
        id: '4',
        meta: {
          title: '考场安排数据导出'
        },
        component: () => import('@/views/examSet/classSet/ClassSetExport.vue'),
        children: [
          {
            path: 'signTable',
            name: 'signTable',
            id: '4-4',
            meta: {
              title: '签到表下载'
            },
            component: () => import('@/views/examSet/classSet/signTable.vue')
          },
        ]
      },
      {
        path: 'journal',
        name: 'journal',
        id: '4-6',
        meta: {
          title: '巡检系统同步日志'
        },
        component: () => import('@/views/examSet/journal/journal.vue')
      },
      {
        path: 'varAudit',
        name: 'varAudit',
        id: '4-7',
        meta: {
          title: "机考人脸验证审核"
        },
        component: () => import('@/views/examSet/varAudit/varAudit.vue')
      },
      {
        path: 'IPReceiveSettings',
        name: 'IPReceiveSettings',
        id: '4-8',
        component: () => import('@/views/examSet/classSet/IPReceiveSettings.vue'),
        meta: {
          title: 'IP提醒接收设置'
        },
        children: [
          {
            path: 'setSettingsIphone',
            name: 'setSettingsIphone',
            id: '4-8',
            meta: {
              title: '添加手机号'
            },
            component: () => import('@/views/examSet/classSet/setSettingsIphone.vue'),

          }
        ]
      },
      {
        path: 'CandidateIPAnalysis',
        name: 'CandidateIPAnalysis',
        id: '4-9',
        component: () => import('@/views/examSet/classSet/CandidateIPAnalysis.vue'),
        meta: {
          title: '考生IP分析'
        },
        children: [
          {
            path: 'CandidateIPAnalysisDetails',
            name: 'CandidateIPAnalysisDetails',
            id: '4-9',
            meta: {
              title: '查看'
            },
            component: () => import('@/views/examSet/classSet/CandidateIPAnalysisDetails.vue'),
          }
        ]
      },
      {
        path: 'examLoginAbnormal',
        name: 'examLoginAbnormal',
        id: '4-10',
        meta: {
          title: "考生异常登录日志查询"
        },
        component: () => import('@/views/examSet/examLogin/examLoginAbnormal.vue')
      },
    ]
  },
  // 机房版考试管理
  {
    path: '/',
    component: Layout,
    id: '13',
    redirect: '/computedRoomExam',
    meta: {
      title: '机房考试',
      icon: 'exam-icon.png',
    },
    children: [
      {
        path: 'examConfigBase',
        name: 'examConfigBase',
        id: '13-17',
        component: () => import('@/views/computedRoomExam/examConfigBase.vue'),
        meta: {
          title: '机房考试参数配置'
        },
      },
      {
        path: 'preExamSet',
        name: 'preExamSet',
        id: '13-1',
        component: () => import('@/views/computedRoomExam/preExamSet.vue'),
        meta: {
          title: '考前设置'
        },
      },
      {
        path: 'exceptionSet',
        name: 'exceptionSet',
        id: '13-2',
        component: () => import('@/views/computedRoomExam/exceptionSet.vue'),
        meta: {
          title: '考点考前例外设置'
        },
      },
      {
        path: 'versionNumber',
        name: 'versionNumber',
        id: '13-13',
        component: () => import('@/views/computedRoomExam/versionNumber.vue'),
        meta: {
          title: '数据包版本号查询'
        }
      },

      {
        path: 'exportDataPackage',
        name: 'exportDataPackage',
        id: "13-3",
        component: () => import('@/views/computedRoomExam/exportDataPackage.vue'),
        meta: {
          title: '考试数据包导出'
        }
      },
      {
        path: 'serialNumber',
        name: 'serialNumber',
        id: '13-7',
        component: () => import('@/views/computedRoomExam/serialNumber.vue'),
        meta: {
          title: '序列号查询'
        },
        children: [
          {
            path: 'queryMachine',
            name: 'queryMachine',
            id: '13-7',
            meta: {
              title: '考试机查询'
            },
            component: () => import('@/views/computedRoomExam/queryMachine.vue'),
          }
        ]
      },
      {
        path: 'secretKey',
        name: 'secretKey',
        id: '13-5',
        component: () => import('@/views/computedRoomExam/secretKey.vue'),
        meta: {
          title: '秘钥查询'
        },
        children: [
          {
            path: 'secretKeyLook',
            name: 'secretKeyLook',
            id: '13-5',
            meta: {
              title: '查看机房进场秘钥'
            },
            component: () => import('@/views/computedRoomExam/secretKeyLook.vue'),
          }
        ]
      },
      {
        path: 'authCode',
        name: 'authCode',
        id: '13-6',
        component: () => import('@/views/computedRoomExam/authCode.vue'),
        meta: {
          title: '授权码查询'
        },
      },
      {
        path: 'importExamZIP',
        name: 'importExamZIP',
        id: "13-15",
        component: () => import('@/views/computedRoomExam/importExamZIP.vue'),
        meta: {
          title: '机考数据导入'
        },
        children: [
          {
            path: 'importExamZIP_Show',
            name: 'importExamZIP_Show',
            id: '13-15',
            meta: {
              title: '查询'
            },
            component: () => import('@/views/computedRoomExam/importExamZIP_Show.vue'),
          }
        ]
      },
      {
        path: 'signSheet',
        name: 'signSheet',
        id: '13-8',
        component: () => import('@/views/computedRoomExam/signSheet.vue'),
        meta: {
          title: '纸质单据管理'
        },
      },
      {
        path: 'tryExam',
        name: 'tryExam',
        id: '13-10',
        component: () => import('@/views/computedRoomExam/tryExam.vue'),
        meta: {
          title: '机器试考情况查询'
        },
      },
      {
        path: "examPhotoQuery",
        name: "examPhotoQuery",
        id: "13-16",
        component: () => import('@/views/computedRoomExam/examPhotoQuery.vue'),
        meta: {
          title: "试考照片管理"
        }
      },

      {
        path: 'examineeDetail',
        name: 'examineeDetail',
        id: '13-12',
        component: () => import('@/views/computedRoomExam/examineeDetail.vue'),
        meta: {
          title: '考生详情查询'
        }
      },


    ]
  },
  // 报名管理
  {
    path: '/',
    id: '3',
    component: Layout,
    redirect: '/applyManage',
    meta: {
      title: '报名管理',
      icon: 'agency-icon.png',
    },
    children: [
      {
        path: 'applyManage',
        name: 'applyManage',
        id: '3-1',
        component: () => import('@/views/applySet/applyManage.vue'),
        meta: {
          title: '报名管理'
        },
        children: [
          {
            path: 'applyManageAdd',
            name: 'applyManageAdd',
            id: '3-1',
            component: () => import('@/views/applySet/applyManageAdd.vue'),
            meta: {
              title: '新增报缴信息'
            },

          },
        ]
      },
      {
        path: 'applyFirst',
        name: 'applyFirst',
        id: '3-2',
        component: () => import('@/views/applySet/applyFirst.vue'),
        meta: {
          title: '报名初审'
        },
        children: [
          {
            path: 'applyAuditDetail',
            name: 'applyFirstDetail',
            id: '3-2',
            component: () => import('@/views/applySet/applyAuditDetail.vue'),
            meta: {
              title: '审核详情'
            },
          },
        ]
      },
      {
        path: 'applyAudit',
        name: 'applyAudit',
        id: '3-3',
        component: () => import('@/views/applySet/applyAudit.vue'),
        meta: {
          title: '报名终审'
        },
        children: [
          {
            path: 'applyAuditDetail',
            name: 'applyAuditDetail',
            id: '3-3',
            component: () => import('@/views/applySet/applyAuditDetail.vue'),
            meta: {
              title: '审核详情'
            },
          },
        ]
      },
      {
        path: 'applyFileUpload',
        name: 'applyFileUpload',
        id: '3-4',
        component: () => import('@/views/applySet/applyFileUpload.vue'),
        meta: {
          title: '报名材料上传'
        },
      },
      {
        path: 'applyFileAudit',
        name: 'applyFileAudit',
        id: '3-5',
        component: () => import('@/views/applySet/applyFileAudit.vue'),
        meta: {
          title: '报名材料审核'
        },
      },

    ]
  },
  // 缴费管理
  {
    path: '/',
    id: '9',
    component: Layout,
    redirect: '/payManagement',
    meta: {
      title: '缴费管理',
      icon: 'JiaoFei.png',
    },
    children: [
      {
        path: 'payManagement',
        name: 'payManagement',
        id: '9-1',
        component: () => import('@/views/applySet/payManagement.vue'),
        meta: {
          title: '缴费管理'
        }
      },
      {
        path: 'payOrders',
        name: 'payOrders',
        id: '9-2',
        component: () => import('@/views/applySet/payOrders.vue'),
        meta: {
          title: '缴费订单'
        }
      },
      {
        path: 'invoiceManage',
        name: 'invoiceManage',
        id: '9-3',
        component: () => import('@/views/applySet/invoiceManage/invoiceManage.vue'),
        meta: {
          title: '发票管理'
        }
      },
    ]
  },
  // 阅卷管理
  {
    path: '/',
    component: Layout,
    id: '8',
    redirect: '/markPaper',
    meta: {
      title: '阅卷管理',
      icon: 'reviewTeacher-icon.png',
    },
    children: [
      {
        path: 'reviewTeacher',
        name: 'reviewTeacher',
        id: '8-1',
        component: () => import('@/views/markPaper/reviewTeacher/reviewTeacher.vue'),
        meta: {
          title: '评阅教师管理'
        }
      },
      {
        path: 'autoAssign',
        name: 'autoAssign',
        id: '8-2',
        component: () => import('@/views/markPaper/autoAssign/autoAssign.vue'),
        meta: {
          title: '评阅自动分配'
        }
      },
      {
        path: 'manuAssign',
        name: 'manuAssign',
        id: '8-3',
        component: () => import('@/views/markPaper/manuAssign/manuAssign.vue'),
        meta: {
          title: '评阅手动分配'
        }
      },
      {
        path: 'situationStatistics',
        name: 'situationStatistics',
        id: '8-4',
        component: () => import('@/views/markPaper/situationStatistics/situationStatistics.vue'),
        meta: {
          title: '评阅情况统计'
        }
      },
      {
        path: 'reviewTimeSet',
        name: 'reviewTimeSet',
        id: '8-6',
        component: () => import('@/views/markPaper/review/reviewTimeSet.vue'),
        meta: {
          title: '评阅时间设置'
        }
      },
      {
        path: 'review',
        name: 'review',
        id: '8-5',
        component: () => import('@/views/markPaper/review/review.vue'),
        meta: {
          title: '教师评阅'
        },
        children: [
          {
            path: "reviewDetail",
            name: "reviewDetail",
            id: "8-5",
            component: () => import('@/views/markPaper/review/reviewDetail.vue'),
            meta: {
              title: "已评阅列表"
            }
          }
        ]
      },

    ]
  },
  // 成绩管理
  {
    path: '/',
    component: Layout,
    id: '10',
    redirect: '/score',
    meta: {
      title: '成绩管理',
      icon: 'ChengJi.png',
    },
    children: [
      {
        path: 'score',
        name: 'score',
        id: '10-1',
        component: () => import('@/views/examSet/score/score.vue'),
        meta: {
          title: '成绩管理'
        },
        children: [
          {
            path: 'currentScore',
            name: 'currentScore',
            id: '10-1',
            meta: {
              title: '考生成绩'
            },
            component: () => import('@/views/examSet/score/currentScore.vue'),
          },
          {
            path: 'singleGrades',
            name: 'singleGrades',
            id: '10-1',
            meta: {
              title: '单科成绩'
            },
            component: () => import('@/views/examSet/score/singleGrades.vue'),
          },
          {
            path: 'setSubCourse',
            name: 'setSubCourse',
            id: '10-1',
            meta: {
              title: '设置单科'
            },
            component: () => import('@/views/examSet/score/setSubCourse.vue'),
          }
        ]
      },
      {
        path: 'scoringSetList',
        name: 'scoringSetList',
        id: '10-14',
        meta: {
          title: '赋分规则查询及设置'
        },
        component: () => import('@/views/examSet/score/scoringSetList.vue'),
        children: [
          {
            path: 'scoringRuleSet',
            name: 'scoringRuleSet',
            id: '10-14',
            meta: {
              title: '设置赋分规则'
            },
            component: () => import('@/views/examSet/score/scoringRuleSet.vue'),
          }
        ]
      },
      {
        path: 'scoringDetails',
        name: 'scoringDetails',
        id: '10-15',
        meta: {
          title: '赋分明细查询'
        },
        component: () => import('@/views/examSet/score/scoringDetails.vue')
      },
      {
        path: 'historyScore',
        name: 'historyScore',
        id: '10-2',
        meta: {
          title: '成绩查询'
        },
        component: () => import('@/views/examSet/score/historyScore.vue')
      },
      {
        path: 'scorereviews',
        name: 'scorereviews',
        id: '10-3',
        component: () => import('@/views/examSet/score/scorereviews.vue'),
        meta: {
          title: '成绩复核'
        },
        children: [{
          path: 'reviewdetails',
          name: 'reviewdetails',
          id: '10-3',
          component: () => import('@/views/examSet/score/reviewdetails.vue'),
          meta: {
            title: '审核详情'
          }
        }
        ]
      },
      {
        path: 'scoreTrial',
        name: 'scoreTrial',
        id: '10-4',
        component: () => import('@/views/examSet/score/scoreTrial.vue'),
        meta: { title: '合格分数线试算' }
      },
      {
        path: "ExemptionExams",
        name: "ExemptionExams",
        id: "10-5",
        component: () => import('@/views/examSet/score/ExemptionExams/ExemptionExams.vue'),
        meta: { title: "免考原因设置" }
      },
      {
        path: "ExemptionApply",
        name: "ExemptionApply",
        id: "10-6",
        component: () => import('@/views/examSet/score/ExemptionExams/ExemptionApply.vue'),
        meta: { title: "考后免考处理" }
      },
      {
        path: "ScoreAdjustmentApplication",
        name: "ScoreAdjustmentApplication",
        id: "10-7",
        component: () => import('@/views/examSet/score/ScoreAdjustment/ScoreAdjustmentApplication.vue'),
        meta: { title: "考生成绩调整申请" }
      },
      {
        path: "ScoreAdjustmentReview",
        name: "ScoreAdjustmentReview",
        id: "10-8",
        component: () => import('@/views/examSet/score/ScoreAdjustment/ScoreAdjustmentReview.vue'),
        meta: { title: "考生成绩调整审核" }
      },
      {
        path: "ThirdPartySet",
        name: "ThirdPartySet",
        component: () => import('@/views/examSet/score/ScoreSynthesis/ThirdPartySet.vue'),
        id: "10-9",
        meta: { title: "第三方成绩项设置" }
      },
      {
        path: "PlanThirdPartySet",
        name: "PlanThirdPartySet",
        component: () => import('@/views/examSet/score/ScoreSynthesis/PlanThirdPartySet.vue'),
        id: "10-10",
        meta: { title: "考试批次第三方成绩项设置" }
      },
      {
        // 成绩考核规则设置
        path: "AssessmentRules",
        name: "AssessmentRules",
        component: () => import('@/views/examSet/score/ScoreSynthesis/AssessmentRules.vue'),
        id: "10-11",
        meta: { title: "成绩考核规则设置" }
      },
      {
        path: "ScoreEntry",
        name: "ScoreEntry",
        component: () => import('@/views/examSet/score/ScoreSynthesis/ScoreEntry.vue'),
        id: "10-12",
        meta: { title: "第三方成绩录入" }
      },
      {
        path: 'scoreLine',
        name: 'scoreLine',
        id: '10-13',
        meta: {
          title: '自定义报表'
        },
        component: () => import('@/views/examSet/scoreLine/scoreLine.vue'),
        children: [
          {
            path: 'scoreLineSet',
            name: 'scoreLineSet',
            id: '10-13',
            component: () => import('@/views/examSet/scoreLine/scoreLineSet.vue'),
            meta: {
              title: '设置课程属性及分控线'
            }
          },
          {
            path: 'scoreLineDetail',
            name: 'scoreLineDetail',
            id: '10-13',
            component: () => import('@/views/examSet/scoreLine/scoreLineDetail.vue'),
            meta: {
              title: '分控线学生明细'
            }
          },
        ]
      },
      {
        path: 'paperAnalysis',
        name: 'paperAnalysis',
        id: '10-16',
        component: () => import('@/views/examSet/score/paperAnalysis/index.vue'),
        meta: {
          title: '试卷难度分析'
        },
        children:[
          {
            path: 'paperAnalysisResult',
            name: 'paperAnalysisResult',
            id: '10-16',
            meta: {
              title: '查看结果'
            },
            component: () => import('@/views/examSet/score/paperAnalysis/result.vue')
          },
          {
            path: 'paperAnalysisDetail',
            name: 'paperAnalysisDetail',
            id: '10-16',
            meta: {
              title: '分析详情'
            },
            component: () => import('@/views/examSet/score/paperAnalysis/detail.vue')
          }
        ]
      }      
    ]
  },
  // 用户管理
  {
    path: '/',
    component: Layout,
    id: "6",
    redirect: '/user',
    meta: {
      title: '用户管理',
      icon: 'User_icon.png',
    },
    children: [
      {
        path: 'rolemanagement',
        name: 'rolemanagement',
        id: "6-1",
        component: () => import('@/views/user/roleManagement/roleManagement.vue'),
        meta: {
          title: '角色管理'
        },
        children: [
          {
            path: 'addUser',
            name: 'addUser',
            id: "6-1",
            component: () => import('@/views/user/roleManagement/addUser.vue'),
            meta: {
              title: '添加用户'
            }
          },
          {
            path: 'getRoleType',
            name: 'getRoleType',
            id: "6-1",
            component: () => import("@/views/user/roleManagement/userRoleType.vue"),
            meta: {
              title: '角色授权'
            }
          }
        ]
      },
      {
        path: '/schooluser',
        name: 'schooluser',
        id: "6-2",
        component: () => import('@/views/user/schooluser/schoolUser.vue'),
        meta: {
          title: '院校用户',
        },
      },
      {
        path: '/stationuser',
        name: 'stationuser',
        id: "6-3",
        component: () => import('@/views/user/stationuser/stationUser.vue'),
        meta: {
          title: '教学点用户',
        },
      },
      {
        path: '/InspectorSuer',
        name: 'InspectorSuer',
        id: "6-5",
        component: () => import('@/views/user/Inspector/InspectorSuer.vue'),
        meta: {
          title: '巡考员用户',
        },
      },
      {
        path: 'studentManageMent',
        name: 'studentManageMent',
        id: '6-4',
        component: () => import('@/views/applySet/studentManage/studentManageMent.vue'),
        meta: {
          title: '学生管理'
        },
        children: [
          {
            path: 'studentManageMentAdd',
            name: 'studentManageMentAdd',
            id: '6-4',
            component: () => import('@/views/applySet/studentManage/studentManageMentAdd.vue'),
            meta: {
              title: '新增学生信息'
            },
          },
        ]
      },
    ]
  },
  // 数据中心
  {
    path: '/',
    id: '11',
    component: Layout,
    redirect: '/examReport',
    meta: {
      title: '数据中心',
      icon: 'data-icon.png',
    },
    children: [
      {
        path: 'examReport',
        name: 'examReport',
        id: '11-1',
        component: () => import('@/views/data/examReport.vue'),
        meta: {
          title: '考试报告'
        }
      },
      {
        path: 'scoreAnalysis',
        name: 'scoreAnalysis',
        id: '11-2',
        component: () => import('@/views/data/scoreAnalysis.vue'),
        meta: {
          title: '成绩分析'
        },
        children: [
          {
            path: 'scoreAnalysisInfo',
            name: 'scoreAnalysisInfo',
            id: '11-2',
            meta: {
              title: '成绩分析详情'
            },
            component: () => import('@/views/data/scoreAnalysisInfo.vue')
          },
        ]
      },
      {
        path: 'scorePart',
        name: 'scorePart',
        id: '11-3',
        component: () => import('@/views/data/scorePart.vue'),
        meta: {
          title: '分数段统计'
        }
      },
      {
        path: 'signing',
        name: 'signing',
        id: '11-4',
        component: () => import('@/views/system/dataV/dataV.vue'),
        meta: {
          title: '数据大屏'
        }
      },
      {
        path: 'intelligentDetecteTemplate',
        name: 'intelligentDetecteTemplate',
        id: '11-5',
        component: () => import('@/views/data/intelligentDetecteTemplate.vue'),
        meta: {
          title: '试题智能检测模板维护'
        }
      },
      {
        path: 'intelligentDetecte',
        name: 'intelligentDetecte',
        id: '11-6',
        component: () => import('@/views/data/intelligentDetecte.vue'),
        meta: {
          title: '试题智能检测'
        },
        children: [
          {
            path: 'taskResult',
            name: 'taskResult',
            id: '11-6',
            meta: {
              title: '检测结果详情'
            },
            component: () => import('@/views/data/taskResult.vue')
          }
        ]
      },
      {
        path: 'planArchive',
        name: 'planArchive',
        id: '11-7',
        component: () => import('@/views/data/planArchive.vue'),
        meta: {
          title: '归档管理'
        }
      }
    ]
  },
  // 公告管理
  {
    path: '/',
    component: Layout,
    id: "7",
    redirect: '/notice',
    meta: {
      title: '公告管理',
      icon: 'notice.png',
    },
    children: [
      {
        path: 'notice',
        name: 'notice',
        id: "7-1",
        component: () => import('@/views/notice/noticeManagement.vue'),
        meta: {
          title: '公告管理'
        },
        children: [
          {
            path: 'add',
            name: 'addNotice',
            id: "7-1",
            component: () => import('@/views/notice/addNotice.vue'),
            meta: {
              title: '新增公告'
            }
          },
          {
            path: 'edit',
            name: 'editNotice',
            id: "7-1",
            component: () => import('@/views/notice/addNotice.vue'),
            meta: {
              title: '编辑公告'
            }
          }
        ]
      },
    ]
  },
  // 督导
  {
    path: '/',
    id: '12',
    component: Layout,
    redirect: '/messagePush',
    meta: {
      title: '督导管理',
      icon: 'DuDao.png',
    },
    children: [
      {
        path: 'messagePush',
        name: 'messagePush',
        id: '12-1',
        component: () => import('@/views/applySet/messagePush.vue'),
        meta: {
          title: '学生督导',
        }
      },
      {
        path: 'messageDetailed',
        name: 'messageDetailed',
        id: '12-2',
        component: () => import('@/views/applySet/messageDetailed.vue'),
        meta: {
          title: '督导明细',
        }
      },
      {
        path: 'askExamManage',
        name: 'askExamManage',
        id: '12-3',
        component: () => import('@/views/applySet/askExamManage.vue'),
        meta: {
          title: '考试确认明细',
        }
      }
    ]
  },
  // 系统设置
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/systemSet',
    id: '5',
    meta: {
      title: '系统设置',
      icon: 'setting-icon.png',
    },
    children: [
      {
        path: 'systemSet',
        name: 'systemSet',
        id: '5-1',
        component: () => import('@/views/system/systemSet'),
        meta: {
          title: '系统设置'
        }
      },
      {
        path: "systemMessage",
        name: "systemMessage",
        id: '5-2',
        component: () => import("@/views/system/systemMessage"),
        meta: {
          title: "短信设置",
        }
      },
      {
        path: "customForm",
        name: "customForm",
        id: '5-3',
        component: () => import("@/views/system/customForm/index.vue"),
        meta: {
          title: "自定义学生信息",
        },
      },
      {
        path: 'TenantCustom',
        name: 'TenantCustom',
        id: '5-4',
        component: () => import('@/views/system/TenantCustom/TenantCustom'),
        meta: {
          title: '个性化设置'
        },
      },
      {
        path: 'TestIndex',
        name: 'TestIndex',
        id: '5',
        component: () => import('@/views/manage/manage'),
        hiddenMenu: true,
        meta: {
          title: '',
        }
      },
      {
        path: "admissionTicket",
        name: "admissionTicket",
        id: "5-5",
        // hiddenMenu: true,
        component: () => import('@/views/system/makePapers/admissionTicket.vue'),
        meta: {
          title: '准考证制作'
        }
      },
      {
        path: "certificateTicket",
        name: "certificateTicket",
        id: "5-7",
        // hiddenMenu: true,
        component: () => import('@/views/system/makePapers/certificateTicket.vue'),
        meta: {
          title: '合格证制作'
        }
      },
      {
        path: "finance",
        name: "finance",
        id: '5-6',
        component: () => import("@/views/system/finance.vue"),
        meta: {
          title: "财务配置",
        },
      },
    ]
  },
  // 预览类别页面(自定义)
  {
    path: '/reviewForm',
    name: 'reviewForm',
    id: "6-3",
    component: () => import('@/views/system/customForm/reviewForm.vue'),
    hiddenMenu: true,
    meta: {
      title: '报名表预览'
    }
  },

  // 预览类别页面(首页效果)
  {
    path: '/TenantCustomShow',
    name: 'TenantCustomShow',
    id: '6',
    component: () => import('@/views/system/TenantCustom/TenantCustomShow'),
    hiddenMenu: true,
    meta: {
      title: '首页效果预览'
    }
  },

  // 靠前设置预览
  {
    path: '/previewPreExam',
    name: 'previewPreExam',
    id: '13',
    component: () => import('@/views/others/previewPreExam'),
    hiddenMenu: true,
    meta: {
      title: '考试机预览'
    }
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: constantRoutes
})


export default router
